import * as React from 'react';

import {
  AlertButton,
  AlertOptions,
  StyleSheet,
  Text,
  TouchableHighlight,
  View,
} from 'react-native';

let instance: AlertViewClass;

interface Props {}

interface State {
  visible: boolean;
  title: string;
  message?: string;
  buttons?: AlertButton[];
  options?: AlertOptions;
}

class AlertViewClass extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      title: '',
    };
  }

  public render() {
    const {visible, message, title, buttons} = this.state;
    if (!visible) {
      return null;
    }
    const isMultiButton = buttons && buttons.length > 2;
    return (
      <View style={styles.wrapper}>
        <View style={styles.background} />
        <View style={styles.container}>
          <View style={styles.textContainer}>
            <Text style={styles.title}>{title}</Text>
            <Text style={styles.message}>{message}</Text>
          </View>
          <View
            style={[
              styles.buttonContainer,
              isMultiButton && styles.buttonContainerMulti,
            ]}>
            {buttons &&
              buttons.map(({text, onPress}, i) => (
                <TouchableHighlight
                  key={i}
                  onPress={this.onButtonPress(onPress)}
                  style={[
                    styles.button,
                    i < buttons.length - 1 &&
                      (isMultiButton
                        ? styles.buttonSpacerMulti
                        : styles.buttonSpacer),
                  ]}
                  underlayColor="#f0f0f0">
                  <Text style={styles.buttonLabel}>{text}</Text>
                </TouchableHighlight>
              ))}
          </View>
        </View>
      </View>
    );
  }

  private onButtonPress = (onPress?: () => void) => () => {
    this.setState({visible: false});
    if (onPress) {
      onPress();
    }
  };
}

const saveRef = (r: AlertViewClass) => {
  instance = r;
};

export default {
  AlertView: () => <AlertViewClass ref={saveRef} />,
  alert(
    title: string,
    message?: string,
    buttons: AlertButton[] = [{text: 'OK'}],
    options?: AlertOptions,
  ) {
    instance.setState({
      visible: true,
      title,
      message,
      buttons,
      options,
    });
  },
  alertNative(title: string) {
    alert(title);
  },
};

const styles = StyleSheet.create({
  background: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.6)',
  },
  wrapper: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'space-around',
    zIndex: 1000,
  },
  container: {
    overflow: 'hidden',
    backgroundColor: '#f8f8f8',
  },
  textContainer: {
    padding: 20,
    justifyContent: 'space-around',
  },
  title: {
    color: '#2b3137',
    fontSize: 17,
    fontWeight: '600',
  },
  message: {
    color: '#2b3137',
    marginTop: 4,
    fontSize: 14,
    maxWidth: 300,
  },
  buttonContainer: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    flex: 1,
    paddingRight: 14,
    paddingBottom: 6,
  },
  buttonContainerMulti: {},
  button: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'space-around',
    flex: 1,
  },
  buttonSpacer: {},
  buttonSpacerMulti: {},
  buttonLabel: {
    color: '#4b8ffe',
    fontSize: 14,
  },
});
